import { cn } from '@/lib/cn';
import { formatBRL } from '@/lib/format';

interface Props {
  valor: number | string | null | undefined;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizes = {
  sm: 'text-[12px]',
  md: 'text-[14px]',
  lg: 'text-[18px]',
  xl: 'text-[28px] tracking-[-0.01em]',
};

export function Money({ valor, size = 'md', className }: Props) {
  return (
    <span
      className={cn('font-mono font-semibold tnum text-fg-1', sizes[size], className)}
    >
      {formatBRL(valor)}
    </span>
  );
}

export default Money;
